import "react";
import { RichTextEditor } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { get } from "lodash-es";
import { Field, useFormikContext } from "formik";
//#region src/components/FormikFields/FormikRichTextEditor.tsx
function FormikRichTextEditor(props) {
	const form = useFormikContext();
	return /* @__PURE__ */ jsx(Field, {
		name: props.name,
		children: ({ field, meta }) => {
			return /* @__PURE__ */ jsx(RichTextEditor, {
				...props,
				error: (meta.touched || !!form.submitCount) && meta.error,
				valid: (meta.touched || !!form.submitCount) && meta.value && !meta.error,
				onChangeValue: (value) => {
					if (props.name) form.setFieldValue(props.name, value.text);
					if (props.htmlName) form.setFieldValue(props.htmlName, value.html);
				},
				...field,
				initialHTML: props.htmlName ? get(form.values, props.htmlName) : void 0,
				onBlur: (e) => {
					if (props.onBlur) props.onBlur(e);
					field.onBlur(e);
				},
				onChange: null
			});
		}
	});
}
//#endregion
export { FormikRichTextEditor };

//# sourceMappingURL=FormikRichTextEditor.js.map